import { DetectionRulesTable } from '@/components/table/DetectionRulesTable/DetectionRulesTable';

export default function DetectionRulesTablePage() {
  return <DetectionRulesTable />;
}
